import React from "react";
import { Button, Grid } from "@material-ui/core";

import CustomList from "./CustomList";
import useTransferTree from "./useTransferTree";

const TransferTree = ({ featureNumber = 0 }) => {
  const {
    searchValRight,
    setSearchValRight,
    searchValLeft,
    setSearchValLeft,
    right,
    left,
    leftChecked,
    rightChecked,
    selected,
    setSelected,
    handleCheckedRight,
    handleCheckedLeft,
    handleApply,
    handleClearAll,
  } = useTransferTree(featureNumber);

  return (
    <div>
      <Grid container spacing={2} justifyContent="center" alignItems="center">
        <Grid item>
          <CustomList
            searchVal={searchValLeft}
            setSearchVal={setSearchValLeft}
            listItems={left}
            listHeader={"Available ZIP"}
            selected={selected}
            setSelected={setSelected}
          />
        </Grid>
        <Grid item>
          <Grid container direction="column" alignItems="center">
            <Button
              sx={{ my: 0.5 }}
              variant="outlined"
              size="small"
              onClick={handleCheckedRight}
              disabled={leftChecked.length === 0}
              aria-label="move selected right"
            >
              &gt;
            </Button>
            <Button
              sx={{ my: 0.5 }}
              variant="outlined"
              size="small"
              onClick={handleCheckedLeft}
              disabled={rightChecked.length === 0}
              aria-label="move selected left"
            >
              &lt;
            </Button>
          </Grid>
        </Grid>
        <Grid item>
          <CustomList
            searchVal={searchValRight}
            setSearchVal={setSearchValRight}
            listItems={right}
            listHeader={"Target/Existing ZIP"}
            selected={selected}
            setSelected={setSelected}
          />
        </Grid>
      </Grid>
      <div
        style={{
          marginTop: 20,
          paddingRight: 88,
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "flex-end",
        }}
      >
        <Button
          style={{
            marginRight: 20,
          }}
          sx={{ my: 0.5 }}
          variant="outlined"
          size="small"
          onClick={() => {
            handleClearAll();
          }}
          disabled={right.length === 0}
          aria-label="Clear All"
        >
          Clear All
        </Button>
        <Button
          sx={{ my: 0.5 }}
          variant="outlined"
          size="small"
          onClick={() => {
            handleApply();
          }}
          disabled={right.length === 0}
          aria-label="Apply"
        >
          Apply
        </Button>
      </div>
    </div>
  );
};

export default TransferTree;
